var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{attrs:{"action":"#","method":"get","name":"form1","id":"form1"}},[_vm._v(" 窗口的实际高度: "),_c('input',{attrs:{"type":"text","name":"availHeight","size":"4"}}),_c('br'),_vm._v(" 窗口的实际宽度: "),_c('input',{attrs:{"type":"text","name":"availWidth","size":"4"}}),_c('br')])])
}]

export { render, staticRenderFns }